export enum EquipmentLookupTypes {
  BARCODE_SCAN = 1,
  EQUIPMENT_SERIAL_NUMBER = 2,
  OUTLET_NUMBER = 3,
  BARCODE_IMAGE = 4,
  OUTLET_PHONE = 5,
  OUTLET_ADDRESS = 6
}
